import { Spinner } from '@blueprintjs/core';
import { compose, withProps } from 'recompose';

import { Widget } from '../Widget';

export default compose(withProps({ padding: '1rem' }), Widget)(Spinner);
